/* Maison du Booster : extrait de snippets/mdb-ux-panier.liquid (23/09, charge en defer) */
  (function () {
    'use strict';
    var MDB = window.MDB = window.MDB || {};
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ROUTES = (typeof Theme !== 'undefined' && Theme.routes) || {};
    var SVG = {
      chargement: '<svg class="mdb-atc__roue" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-dasharray="36 100"/></svg>',
      succes: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      erreur: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M12 7.6v5.4M12 16.4v.1" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
    };
    var minuteries = new WeakMap();

    /* (sans interaction réelle de l'utilisateur, le navigateur refuse la vibration et le signale en console) */
    function vibrer(m) {
      if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return;
      if (MDB.vibrer) MDB.vibrer(m);
    }

    /* état visuel d'un bouton : null (normal) | 'chargement' | 'succes' | 'erreur' ; duree = retour automatique */
    function etat(b, nom, texte, duree) {
      if (!b) return;
      clearTimeout(minuteries.get(b));
      if (!nom) {
        b.removeAttribute('data-mdb-etat');
        b.removeAttribute('aria-busy');
        b.removeAttribute('aria-disabled');
        return;
      }
      var couche = b.querySelector(':scope > .mdb-atc');
      if (!couche) {
        couche = document.createElement('span');
        couche.className = 'mdb-atc';
        couche.setAttribute('aria-hidden', 'true');
        b.appendChild(couche);
      }
      couche.innerHTML = SVG[nom] + '<span class="mdb-atc__texte"></span>';
      couche.lastChild.textContent = texte;
      couche.classList.toggle('mdb-atc--icone', b.clientWidth > 0 && b.clientWidth < 104);
      b.setAttribute('data-mdb-etat', nom);
      if (nom === 'chargement') { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
      else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
      if (duree) minuteries.set(b, setTimeout(function () { etat(b, null); }, duree));
    }

    /* pas de double envoi pendant le chargement (le bouton garde le focus : pas d'attribut disabled) */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-mdb-etat="chargement"]') : null;
      if (b) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* notification : dans le tiroir (fenêtre modale) si elle est ouverte, sinon en bas de page ; le conteneur partagé
       (MDB.toast) est déplacé au bon endroit avant l'affichage */
    function dialogueOuvert() {
      /* tiroir panier ouvert (modal sur mobile, « à côté » de la page sur ordinateur) : la notification y va */
      var d = document.querySelector('theme-drawer#cart-drawer[open] dialog[open]');
      if (!d) { try { d = document.querySelector('dialog[open]:modal'); } catch (err) { d = null; } }
      var tiroir = d ? d.closest('theme-drawer') : null;
      return tiroir && !tiroir.hasAttribute('open') ? null : d;   /* tiroir en train de se fermer : ignoré */
    }
    function toast(texte, o) {
      if (!MDB.toast || !document.body) return;
      var dlg = dialogueOuvert(), hote = dlg || document.body;
      var c = document.querySelector('.mdb-toasts'), deplace = false;
      if (!c) {
        c = document.createElement('div');
        c.className = 'mdb-toasts';
        c.setAttribute('role', 'status');
        c.setAttribute('aria-live', 'polite');
      }
      if (c.parentElement !== hote) { hote.appendChild(c); deplace = true; }
      c.classList.toggle('mdb-toasts--tiroir', !!dlg);
      var resume = dlg ? dlg.querySelector('.cart-drawer__summary') : null;
      if (resume) c.style.setProperty('--mdb-toasts-decalage', Math.round(resume.getBoundingClientRect().height) + 'px');
      else c.style.removeProperty('--mdb-toasts-decalage');
      /* une zone « live » tout juste insérée n'est pas toujours annoncée : court délai dans ce cas */
      var poignee = { fermer: function () { poignee.annule = true; if (poignee.h) poignee.h.fermer(); } };
      function lancer() { if (!poignee.annule) poignee.h = MDB.toast(texte, o); }
      if (deplace) setTimeout(lancer, 60); else lancer();
      return poignee;
    }

    function ouvrirPanier() {
      var t = document.querySelector('theme-drawer#cart-drawer');
      if (t && typeof t.open === 'function') t.open();
      else location.href = ROUTES.cart_url || '/cart';
    }

    function bump() {
      if (reduit) return;
      document.querySelectorAll('cart-icon').forEach(function (c) {
        c.classList.remove('mdb-bump');
        void c.offsetWidth;
        c.classList.add('mdb-bump');
        clearTimeout(c.mdbBump);
        c.mdbBump = setTimeout(function () { c.classList.remove('mdb-bump'); }, 700);
      });
    }

    /* ---------- ajout au panier (fiche, barre collante, ajout rapide) ---------- */
    var erreurs = new WeakMap();
    document.addEventListener('shopify:cart:error', function (e) {
      var f = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
      if (f) erreurs.set(f, String((e.detail && e.detail.description) || e.error || ''));
    });

    function boutonsAjout(form) {
      var liste = Array.prototype.slice.call(form.querySelectorAll('[ref="addToCartButton"]'));
      /* la barre collante « clique » le bouton principal (data-puppet) : son propre bouton reçoit aussi l'état */
      if (liste[0] && liste[0].dataset.puppet === 'true') {
        document.querySelectorAll('sticky-add-to-cart [ref="addToCartButton"]').forEach(function (b) {
          var s = b.closest('sticky-add-to-cart');
          if (!form.dataset.productId || (s && s.dataset.productId === form.dataset.productId)) liste.push(b);
        });
      }
      return liste;
    }

    var dernierSucces = null;
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.action !== 'add' || !e.promise) return;
      var form = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
      if (!form) return;
      var boutons = boutonsAjout(form), debut = Date.now();
      erreurs.delete(form);
      boutons.forEach(function (b) { etat(b, 'chargement', 'Ajout…'); });
      function ensuite(fn) { setTimeout(fn, Math.max(0, 280 - (Date.now() - debut))); }   /* pas de clignotement */
      e.promise.then(function (r) {
        var d = (r && r.detail) || {};
        ensuite(function () {
          if (d.didError) return echec(form, boutons, erreurs.get(form));
          boutons.forEach(function (b) { etat(b, 'succes', 'Ajouté', 2400); });
          vibrer(15);
          bump();
          var t = document.querySelector('theme-drawer#cart-drawer');
          if (t && t.hasAttribute('open')) return;   /* tiroir déjà ouvert : la ligne apparaît, pas besoin de notification */
          if (dernierSucces) dernierSucces.fermer();   /* ajouts successifs : une seule notification à la fois */
          dernierSucces = toast('Ajouté au panier', { type: 'succes', action: { libelle: 'Voir le panier', fn: ouvrirPanier }, duree: 5000 });
        });
      }, function (err) {
        if (err && err.name === 'AbortError') { boutons.forEach(function (b) { etat(b, null); }); return; }
        ensuite(function () {
          echec(form, boutons, 'Connexion interrompue : l’article n’a pas été ajouté. Vérifiez votre connexion, puis réessayez.');
        });
      });
    });

    function echec(form, boutons, message) {
      message = message || 'L’article n’a pas pu être ajouté. Réessayez dans un instant.';
      /* message Shopify « 3 articles seulement ont été ajoutés... » : le chiffre est le total dans le panier, pas
         le nombre ajouté ; reformulé pour être exact */
      var n = /(\d+)\s+articles?\s+seulement/i.exec(message);
      if (n) message = 'Stock limité : votre panier contient maintenant ' + (n[1] === '1' ? 'le seul exemplaire disponible.' : 'les ' + n[1] + ' exemplaires disponibles.');
      var stock = /disponib|stock|seulement|épuis|plus de|maximale/i.test(message);
      boutons.forEach(function (b) { etat(b, 'erreur', stock ? 'Stock limité' : 'Non ajouté', 3500); });
      vibrer([30, 60, 30]);
      toast(message, stock ? { type: 'erreur', duree: 7000, action: { libelle: 'Voir le panier', fn: ouvrirPanier } } : { type: 'erreur', duree: 6000 });
    }

    /* ---------- suppression d'une ligne : « Article retiré — Annuler » ---------- */
    function raccourcir(t, n) { t = (t || '').replace(/\s+/g, ' ').trim(); return t.length > n ? t.slice(0, n - 1).trim() + '…' : t; }

    function sectionsPanier() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
        if (ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId);
      });
      return ids;
    }

    /* remet des articles au panier et prévient le thème (même événement qu'un ajout depuis une fiche : le tiroir, la
       page panier, le compteur et les lecteurs d'écran se mettent à jour) */
    /* @shopify/events : fourni par un petit module EN LIGNE du snippet (window.MDB.shopifyEvents). Surtout pas de
       chargement dynamique ici : dans un fichier assets/*.js, Shopify le reecrit en require() (inexistant dans le
       navigateur) -> « Annuler » rechargeait la page (constate le 23/09). */
    function evenementsShopify() {
      return new Promise(function (ok, ko) {
        var n = 0;
        (function attendre() {
          if (window.MDB && window.MDB.shopifyEvents) return ok(window.MDB.shopifyEvents);
          if (++n > 60) return ko(new Error('@shopify/events indisponible'));
          setTimeout(attendre, 50);
        })();
      });
    }

    function remettre(articles) {
      garderFocus(null, [400, 1200, 2500]);   /* la notification (et son bouton) disparaît */
      evenementsShopify().then(function (m) {
        var Ev = m.CartLinesUpdateEvent, attente = Ev.createPromise();
        document.dispatchEvent(new Ev({
          action: 'add', context: 'cart', promise: attente.promise,
          lines: articles.map(function (a) { return { merchandiseId: String(a.id), quantity: a.quantity }; })
        }));
        var reponse;
        fetch(ROUTES.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: articles.map(function (a) { return { id: a.id, quantity: a.quantity }; }),
            sections: sectionsPanier().join(','), sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (rep) {
          reponse = rep;
          return fetch((ROUTES.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (panier) {
          var rate = !!(reponse && reponse.status);
          attente.resolve({ cart: Ev.createCartFromAjaxResponse(panier), detail: {
            items: panier.items, itemCount: panier.item_count, source: 'mdb-ux-panier', didError: rate,
            sections: rate ? undefined : reponse.sections } });
          if (rate) { toast(reponse.description || reponse.message || 'L’article n’a pas pu être remis au panier.', { type: 'erreur', duree: 6000 }); return; }
          vibrer(15);
          toast(articles.length > 1 ? 'Articles remis dans le panier' : 'Article remis dans le panier', { type: 'succes', duree: 2500 });
        }).catch(function (err) {
          attente.reject(err);
          toast('Connexion interrompue : l’article n’a pas pu être remis au panier.', { type: 'erreur', duree: 6000 });
        });
      }).catch(function () { location.reload(); });
    }

    /* suppression lancée au clavier ? (Entrée / Espace juste avant) : on placera le focus sur « Annuler » */
    var dernierClavier = 0;
    document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') dernierClavier = Date.now(); }, true);
    document.addEventListener('pointerdown', function () { dernierClavier = 0; }, true);

    /* le focus ne doit pas se perdre quand la ligne qui le portait disparaît (ni quand la notification se ferme) */
    function garderFocus(comp, delais) {
      (delais || [350, 900, 1600, 7600, 8400]).forEach(function (ms) {
        setTimeout(function () {
          var a = document.activeElement;
          if (a && a !== document.body && a.isConnected) return;
          comp = comp && comp.isConnected ? comp : (document.querySelector('dialog[open] cart-items-component') || document.querySelector('cart-items-component'));
          if (!comp) return;
          var cible = null;
          comp.querySelectorAll('.cart-items__title, .mdb-panier-vide__cta').forEach(function (el) {
            if (!cible && !el.closest('.removing')) cible = el;
          });
          cible = cible || document.getElementById('cart-drawer-heading');
          if (cible) { try { cible.focus({ preventScroll: true }); } catch (err) {} }
        }, ms);
      });
    }

    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.action !== 'remove' || !e.promise || !e.lines) return;
      var comp = e.target && e.target.closest ? e.target.closest('cart-items-component') : null;
      if (!comp) return;
      var articles = [];
      e.lines.forEach(function (l) {
        if (l.quantity !== 0) return;
        var cle = String(l.id || '').replace(/^gid:\/\/shopify\/CartLine\//, '').split('?')[0];
        var ligne = null;
        comp.querySelectorAll('[data-key]').forEach(function (r) { if (r.dataset.key === cle) ligne = r; });
        if (!ligne) return;
        var champ = ligne.querySelector('input[data-cart-line]');
        var qte = parseInt(champ && (champ.getAttribute('value') || champ.defaultValue), 10) || 1;
        var titre = ligne.querySelector('.cart-items__title');
        articles.push({ id: parseInt(cle.split(':')[0], 10), quantity: qte, titre: titre ? titre.textContent : '' });
      });
      if (!articles.length || !articles[0].id) return;
      var auClavier = Date.now() - dernierClavier < 1500;
      vibrer(10);
      garderFocus(comp);
      e.promise.then(function (r) {
        if (r && r.detail && r.detail.didError) return;
        var texte = articles.length > 1 ? 'Articles retirés du panier' : 'Retiré : ' + raccourcir(articles[0].titre, 40);
        toast(texte, { type: 'info', action: { libelle: 'Annuler', fn: function () { remettre(articles); } }, duree: 7000 });
        if (auClavier) setTimeout(function () {
          var boutons = document.querySelectorAll('.mdb-toasts .mdb-toast__action');
          var dernier = boutons[boutons.length - 1];
          if (dernier) dernier.focus();
        }, 150);
      }, function () {});
    });

    /* quantité : retour haptique à chaque +/- dans le panier */
    document.addEventListener('quantity-selector:update', function (e) {
      if (e.detail && e.detail.cartLine) vibrer(8);
    });

    /* bouton de paiement : état « ouverture » immédiat (la page de paiement met 1 à 2 s à s'afficher) */
    document.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (!s || s.name !== 'checkout' || e.defaultPrevented) return;
      etat(s, 'chargement', 'Ouverture du paiement…', 10000);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-mdb-etat]').forEach(function (b) { etat(b, null); });
    });

    /* barre d'achat collante visible : les notifications passent au-dessus (jamais sous le pouce) */
    function suivreBarre() {
      var barre = document.querySelector('.sticky-add-to-cart__bar');
      if (!barre || !window.MutationObserver) return;
      function maj() {
        var h = barre.getAttribute('data-stuck') === 'true' ? barre.offsetHeight : 0;
        var s = document.documentElement.style;
        if (h) s.setProperty('--mdb-toasts-decalage', Math.round(h + (window.innerWidth >= 750 ? 20 : 0)) + 'px');
        else s.removeProperty('--mdb-toasts-decalage');
      }
      new MutationObserver(maj).observe(barre, { attributes: true, attributeFilter: ['data-stuck'] });
      maj();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suivreBarre); else suivreBarre();
  })();
